/**
 * Sort countries alphabetically by its label
 * @param {object[]} countries
 * @param {string} locale
 * @returns {object[]}
 */
export default (countries, locale) => {
	const language = locale.slice(0, 2);
	return countries.sort((firstElement, secondElement) => {
		if (firstElement.label && secondElement.label) {
			return firstElement.label.localeCompare(secondElement.label, language);
		}
		// If label does not exist (for unknown reason), return unsorted version
		return null;
	});
};
